var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHeinsohnBlanco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 278.048,
    height: 80.717,
    viewBox: "0 0 278.048 80.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16932",
    "data-name": "Grupo 16932",
    transform: "translate(841 -739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3905",
    "data-name": "Grupo 3905",
    transform: "translate(-745.912 765.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4832",
    "data-name": "Trazado 4832",
    d: "M257.534,74.368V62.906h-9.269V74.368H242.92V46.983h5.345V58.175h9.269V46.983h5.349V74.368Z",
    transform: "translate(-242.92 -46.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4833",
    "data-name": "Trazado 4833",
    d: "M310.027,74.368V46.983h18.039v4.769H315.374v6.423H326.18v4.769H315.374V69.6h12.692v4.771Z",
    transform: "translate(-283.759 -46.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2325",
    "data-name": "Rect\\xE1ngulo 2325",
    width: 5.346,
    height: 27.385,
    transform: "translate(49.461 0.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4834",
    "data-name": "Trazado 4834",
    d: "M415.24,74.368l-10.846-16.81v16.81h-5.346V46.983h4.77l10.845,16.77V46.983h5.347V74.368Z",
    transform: "translate(-337.934 -46.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4835",
    "data-name": "Trazado 4835",
    d: "M482.573,65.933a7.449,7.449,0,0,1-2.943,6.133,9.81,9.81,0,0,1-3.21,1.617,13.793,13.793,0,0,1-4,.556,18.13,18.13,0,0,1-5.559-.786,10.879,10.879,0,0,1-4.444-2.827l3.462-3.463a6.98,6.98,0,0,0,3,1.808,12.716,12.716,0,0,0,3.615.5,6.278,6.278,0,0,0,3.616-.864,2.891,2.891,0,0,0,1.23-2.521,3.029,3.029,0,0,0-.845-2.306,3.181,3.181,0,0,0-.943-.6,7.006,7.006,0,0,0-1.481-.366l-3.307-.461a9.264,9.264,0,0,1-5.31-2.269A7.282,7.282,0,0,1,463.5,54.7a8.417,8.417,0,0,1,.655-3.367,7.329,7.329,0,0,1,1.884-2.614,8.772,8.772,0,0,1,3-1.711,12.141,12.141,0,0,1,4-.615,15.271,15.271,0,0,1,4.962.729,10.449,10.449,0,0,1,3.884,2.461L478.5,52.932a5.945,5.945,0,0,0-2.788-1.558,13.194,13.194,0,0,0-2.827-.327,4.393,4.393,0,0,0-3.192,1.02,3.292,3.292,0,0,0-1.04,2.442,2.9,2.9,0,0,0,.192,1.038,2.651,2.651,0,0,0,.617.923,4.036,4.036,0,0,0,1.057.672,5.275,5.275,0,0,0,1.482.406l3.229.461a12.758,12.758,0,0,1,3.118.788,7.342,7.342,0,0,1,2.114,1.327,6.039,6.039,0,0,1,1.615,2.5,10.23,10.23,0,0,1,.5,3.309",
    transform: "translate(-376.498 -46.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4836",
    "data-name": "Trazado 4836",
    d: "M544.459,60.317q0,1.77-.039,3.309a17.971,17.971,0,0,1-.289,2.882,10.047,10.047,0,0,1-.807,2.52,7.908,7.908,0,0,1-1.6,2.212,9.811,9.811,0,0,1-7.385,3,10.53,10.53,0,0,1-4.153-.767,10.287,10.287,0,0,1-3.27-2.231,7.949,7.949,0,0,1-1.595-2.212,9.613,9.613,0,0,1-.789-2.52,19.751,19.751,0,0,1-.268-2.882q-.04-1.54-.039-3.309t.039-3.307a19.8,19.8,0,0,1,.268-2.884,9.609,9.609,0,0,1,.789-2.52,7.946,7.946,0,0,1,1.595-2.21,10.312,10.312,0,0,1,3.27-2.231,10.529,10.529,0,0,1,4.153-.769,9.822,9.822,0,0,1,7.385,3,7.906,7.906,0,0,1,1.6,2.21,10.042,10.042,0,0,1,.807,2.52,18.019,18.019,0,0,1,.289,2.884q.038,1.539.039,3.307m-5.347,0q0-1.962-.057-3.25a16.908,16.908,0,0,0-.211-2.134,4.94,4.94,0,0,0-.422-1.365,4.477,4.477,0,0,0-.653-.942,4.358,4.358,0,0,0-1.445-1.059,4.635,4.635,0,0,0-1.981-.4,4.786,4.786,0,0,0-2,.4,4.306,4.306,0,0,0-1.461,1.059,3.906,3.906,0,0,0-.635.942,5.334,5.334,0,0,0-.4,1.365,16.021,16.021,0,0,0-.213,2.134q-.056,1.288-.057,3.25t.057,3.252a16.049,16.049,0,0,0,.213,2.134,5.363,5.363,0,0,0,.4,1.365,3.906,3.906,0,0,0,.635.942,4.27,4.27,0,0,0,1.461,1.056,4.75,4.75,0,0,0,2,.4,4.6,4.6,0,0,0,1.981-.4,4.32,4.32,0,0,0,1.445-1.056,4.477,4.477,0,0,0,.653-.942,4.966,4.966,0,0,0,.422-1.365,16.938,16.938,0,0,0,.211-2.134q.057-1.291.057-3.252",
    transform: "translate(-414.115 -46.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4837",
    "data-name": "Trazado 4837",
    d: "M604.278,74.368V62.906h-9.271V74.368h-5.345V46.983h5.345V58.175h9.271V46.983h5.346V74.368Z",
    transform: "translate(-453.934 -46.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4838",
    "data-name": "Trazado 4838",
    d: "M672.969,74.368l-10.848-16.81v16.81h-5.344V46.983h4.768l10.847,16.77V46.983h5.345V74.368Z",
    transform: "translate(-494.778 -46.753)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3906",
    "data-name": "Grupo 3906",
    transform: "translate(-841 739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4839",
    "data-name": "Trazado 4839",
    d: "M66.607,16.577A55.5,55.5,0,0,0,41.081,1.631c-10.5-2.808-19.673-2-27.446,2.519v.057C4.524,9.417,0,17.835,0,29.29A44.209,44.209,0,0,0,8.007,54.6a61.846,61.846,0,0,0,8.527,10.137C27.443,75.334,39.511,80.661,52.623,80.717c11.489,0,20.019-4.352,25.472-12.941A28.911,28.911,0,0,0,82.446,54.6a36.425,36.425,0,0,0-1.217-13c-2.322-9.277-7.2-17.581-14.622-25.027M41.658,5.812a48.38,48.38,0,0,1,22.572,13A47.746,47.746,0,0,1,77.051,40.916,32.593,32.593,0,0,1,77.574,54.6,25.041,25.041,0,0,1,73.8,63.6c-4.817,7.156-12.244,10.594-22.224,10.42C40.557,73.79,30.46,69.151,21.293,60.271A55.94,55.94,0,0,1,16.245,54.6c-5.976-7.5-9.05-15.576-9.283-24.282C6.787,20.53,10.442,13.256,18.044,8.559V8.5C24.657,4.38,32.49,3.52,41.658,5.812",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4840",
    "data-name": "Trazado 4840",
    d: "M135,48.078c-1.219-.288-1.684.23-1.51,1.374l.465,2.978a2.505,2.505,0,0,0,2.2,2.119l3.135.63c1.1.228,1.566-.288,1.335-1.432l-.465-2.861a2.637,2.637,0,0,0-2.147-2.121Z",
    transform: "translate(-81.217 -29.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4841",
    "data-name": "Trazado 4841",
    d: "M73.745,41.767c1.392.228,1.971-.29,1.855-1.491l-.405-3.151a2.453,2.453,0,0,0-2.2-2.29l-3.657-.8c-1.392-.286-2.029.228-1.914,1.431l.35,3.208c.057,1.26.81,2,2.263,2.29Z",
    transform: "translate(-41.02 -20.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4842",
    "data-name": "Trazado 4842",
    d: "M156.148,138.167l-.7-3.668c-.288-1.432-.986-2.176-2.261-2.233l-3.366-.4c-1.276-.116-1.857.514-1.566,1.888l.638,3.779a2.441,2.441,0,0,0,2.379,2.29l3.423.288c1.219.116,1.741-.573,1.451-1.946",
    transform: "translate(-90.18 -80.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4843",
    "data-name": "Trazado 4843",
    d: "M143.546,70.262a2.382,2.382,0,0,0-2.09-2.062l-3.073-.514c-1.276-.289-1.8.226-1.627,1.372l.582,3.151a2.5,2.5,0,0,0,2.2,2.174l3.19.516c1.16.171,1.624-.343,1.451-1.487Z",
    transform: "translate(-83.205 -41.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4844",
    "data-name": "Trazado 4844",
    d: "M140.4,89.492l.579,3.436a2.461,2.461,0,0,0,2.264,2.176l3.188.4c1.221.171,1.742-.343,1.513-1.6l-.64-3.265a2.388,2.388,0,0,0-2.145-2.121l-3.135-.571c-1.333-.173-1.913.343-1.622,1.546",
    transform: "translate(-85.4 -53.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4845",
    "data-name": "Trazado 4845",
    d: "M77.358,57.935a2.574,2.574,0,0,0-2.264-2.29l-3.77-.687c-1.394-.286-2.09.228-1.974,1.489l.288,3.436a2.535,2.535,0,0,0,2.38,2.347l3.829.575c1.336.285,1.971-.287,1.855-1.547Z",
    transform: "translate(-42.196 -33.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4846",
    "data-name": "Trazado 4846",
    d: "M78.073,85.1c1.452.228,2.032-.4,1.858-1.717l-.406-3.493a2.447,2.447,0,0,0-2.321-2.4l-3.832-.575c-1.449-.286-2.146.287-1.972,1.66l.29,3.611a2.424,2.424,0,0,0,2.439,2.345Z",
    transform: "translate(-43.436 -46.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4847",
    "data-name": "Trazado 4847",
    d: "M104.09,103.8l-3.712-.516c-1.451-.229-2.031.4-1.858,1.831l.407,3.726a2.556,2.556,0,0,0,2.437,2.4l3.828.4q2,.169,1.743-1.892l-.526-3.665a2.432,2.432,0,0,0-2.32-2.29",
    transform: "translate(-59.938 -62.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4848",
    "data-name": "Trazado 4848",
    d: "M80.326,108.538c1.451.229,2.147-.459,1.974-1.833l-.406-3.84a2.6,2.6,0,0,0-2.438-2.4l-3.886-.516c-1.509-.171-2.263.457-2.088,1.833l.349,3.894a2.541,2.541,0,0,0,2.491,2.519Z",
    transform: "translate(-44.703 -60.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4849",
    "data-name": "Trazado 4849",
    d: "M81.85,124.929l-4-.4c-1.625-.171-2.321.457-2.147,2.062l.408,4.067a2.388,2.388,0,0,0,2.552,2.519l4.12.344c1.508.114,2.2-.628,2.028-2.061l-.463-4.064a2.574,2.574,0,0,0-2.5-2.464",
    transform: "translate(-46.052 -75.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4850",
    "data-name": "Trazado 4850",
    d: "M151.163,111.91a2.346,2.346,0,0,0-2.144-2.174l-3.193-.457c-1.334-.23-1.915.343-1.68,1.718l.58,3.55a2.574,2.574,0,0,0,2.379,2.233l3.364.4c1.161.116,1.682-.457,1.452-1.774Z",
    transform: "translate(-87.691 -66.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4851",
    "data-name": "Trazado 4851",
    d: "M127.251,106.871l-3.422-.514c-1.334-.23-1.915.4-1.742,1.774l.526,3.667a2.526,2.526,0,0,0,2.375,2.29l3.483.342c1.391.173,1.914-.4,1.68-1.774l-.579-3.607a2.374,2.374,0,0,0-2.322-2.178",
    transform: "translate(-74.28 -64.696)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeinsohnBlanco);
export default __webpack_public_path__ + "static/media/logoHeinsohnBlanco.da1e4ba4813432023a3ae3bf67c9cbd5.svg";
export { ForwardRef as ReactComponent };